<!-- 企业认证信息审核 -->
<template>
  <div>
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="15">
        <el-card class="box-card card">
          <el-row class="title-box">
            <el-col :span="24">
              <div class="grid-content bg-purple-dark info-box">
                <span class="title">企业认证信息审核</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-form :label-position="labelPosition" label-width="148px">
                  <el-form-item label="公司LOGO">
                    <div v-if="detailData.logo" style="margin-left: 20px">
                      <el-image
                          style="width:  255.53px;height: 170px;"
                          class="image"
                          :src="detailData.logo"
                          :preview-src-list="srcList2">

                      </el-image>
                    </div>
                    <div v-else style="padding-left: 15px">
                      暂无logo
                    </div>
                  </el-form-item>


                  <el-form-item label="公司名称">
                    <el-input v-model="detailData.name" readonly="readonly" class="inp text-bg define-inp"></el-input>
                  </el-form-item>


                  <el-form-item label="企业类型">
                    <el-input v-model="detailData.companyNature" readonly="readonly"
                              class="inp text-bg define-inp"></el-input>
                  </el-form-item>

                  <el-form-item label="企业所在地">
                    <el-input v-model="detailData.companyCity" readonly="readonly"
                              class="inp text-bg define-inp"></el-input>
                  </el-form-item>

                  <el-form-item label="详细地址">
                    <el-input v-model="Detailedaddress" readonly="readonly" class="inp text-bg define-inp"></el-input>
                  </el-form-item>

                  <!-- <el-form-item label="负责人姓名">
                    <el-input v-model="detailData.userName" readonly="readonly"
                              class="inp text-bg define-inp"></el-input>
                  </el-form-item> -->


                  <!-- <el-form-item label="负责人联系方式">
                    <el-input v-model="detailData.tel" readonly="readonly" class="inp text-bg define-inp"></el-input>
                  </el-form-item> -->
                  <el-form-item label="企业风采" style="">
                    <el-col :span="20">
                      <div v-if="companyPhotoList.length > 0" style="margin-left: 20px">
                        <el-image
                            style="width:  255.53px;height: 170px;"
                            v-for="(item,index) in companyPhotoList" :key="index"
                            class="image"
                            :src="item.url"
                            :preview-src-list="srcList">
                        </el-image>
                      </div>
                      <div v-else style="padding-left: 20px">
                        暂无企业风采
                      </div>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="营业执照">
                    <el-col :span="20">
                      <div v-if="detailData.approve" style="margin-left: 20px">
                        <el-image
                            style="width:  255.53px;height: 170px;"
                            class="image"
                            :src="detailData.approve"
                            :preview-src-list="srcListApprove">
                        </el-image>
                      </div>
                      <div v-else style="padding-left: 20px">
                        暂无营业执照
                      </div>
                    </el-col>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>
          <!--          v-if="detailData.approveStatus==1"-->
<!--          <el-row type="flex" justify="center" class="btn-list">-->
<!--            <el-col :span="13" style="text-align:center;">-->
<!--              <el-button type="primary theme-btn" class="btn pass" @click.native="submitRemake(2,remake)">通过</el-button>-->
<!--              <el-button class="btn refuse" @click.native="alertRemakeFn">拒绝</el-button>-->
<!--            </el-col>-->
<!--          </el-row>-->
        </el-card>
      </el-col>
    </el-row>

    <!-- 审核理由对话框 -->
    <el-dialog
        :visible.sync="showRemake"
        width="30%"
    >
      <div>
        <el-input
            type="textarea"
            class="checkText"
            :rows="10"
            placeholder="请输入拒绝理由"
            maxlength="99"
            show-word-limit
            v-model="remake">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showRemake = false">取 消</el-button>
                <el-button class="theme-btn" type="primary" @click.native="submitRemake(3,remake)">提 交</el-button>
            </span>
    </el-dialog>

  </div>
</template>
<script>

import login from "@/views/login/login";

export default {
  data() {
    return {
      labelPosition: 'right',
      label: '统一社会信用代码\n或注册号',
      showRemake: false,
      remake: '',  // 审核理由
      companyName: '', // 公司名称
      code: '',    // 统一社会信用代码或注册号
      address: '',  // 地址(营业执照地址)
      businessScope: '',   // 经营范围
      enterpriseInfo: [],   // 所有数据
      srcList: [],  // 存放所有图片数据
      srcList2: [], // 企业logo
      companyPhotoList: '', // 公司相册url
      detailData: "", // 公司详情数据
      Detailedaddress: "", // 公司详细地址
      srcListApprove: [],
      logo: "",
    }
  },
  created() {
    this.lastParames = JSON.parse(this.$route.query.params)
    this.Businessdetails(this.lastParames)
  },
  mounted() {

  },
  methods: {
    // 获取企业详情数据
    Businessdetails(id) {
      this.axiosGet(`/web/companyApprove/findCompanyById/${id}`).then((res) => {
        if (res.code == 200) {
          this.companyPhotoList = res.data.companyPhotoList // 企业风采
          this.detailData = res.data
          this.srcList2.push(this.detailData.logo)
          this.srcListApprove.push(res.data.approve)
          this.companyPhotoList.forEach((v) => {
            this.srcList.push(v.url)
          })

          // console.log(this.companyPhotoList)

          this.Detailedaddress = res.data.companyCity + res.data.companyArea + res.data.companyAddress
        }
      })
    },
    alertRemakeFn() {
      this.showRemake = true;
    },
    submitRemake(status, remake) {    // 2 通过  3拒绝
      let id = this.item.id
      let that = this
      this.axiosPost(`/web/companyApprove/checkout`,
          {
            id: id,
            approveStatus: status,
            remake: remake
          }
      ).then((res) => {
        let status = res.code == 200 ? 'success' : 'error'
        this.$message({
          showClose: true,
          message: res.message,
          type: status,
          duration: 1500
        });
        that.$emit('statusFun', true)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.inp {
  width: 80%;
  padding-left: 2%;
  border-radius: 4px;
}

.num {
  font-size: 48px;
  font-weight: 500;
  color: #197FFB;
  line-height: 74px;
  margin-right: 10px;
}

.info-box {
  padding-left: 50px;
}

.form {
  padding-left: 78px;
}

.title-box {
  margin: 20px 0;

  .title {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
    position: relative;
    bottom: 5px;
  }
}

.chck {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}

.el-col-offset-8 {
  margin-left: 40.3333%
}

.btn_fb {
  margin-top: 20px;
}

.image {
  width: 30%;
  height: 170px;;
  margin-right: 3%;
}

.image:last-child {
  margin-right: 0;
}

.btn {
  width: 40%;
  height: 46px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 400;
}

.pass {
  margin-right: 51px;
}

.refuse {
  color: #1A80FC;
  background: #EEF2FB;
}

// .btn-list{
//     margin-top:230px;
// }

// .el-form-item__label{
//     white-space:pre-line;
//     text-align:left;
// }

// //如果是table的话就
// .el-table .cell{
//     white-space:pre-line;
// }


.row-bg {
  margin-top: 20px;
}

</style>
